export enum PickerType{
  Both = 1 ,
  Calendar = 2,
  Timer = 3,
  }